<template>
  <main-layout :selectedMenu="'home'">
    <div class="do-competition contantGeek" v-if="language==='zh'">
      <div class="geekBoxs eventintros">
        <div class="geekBanner">
          <div class="do-banner">
            <img src="/static/geekBanner.jpg" alt />
          </div>
          <div class="rightNavList">
            <ul>
              <!--<p>导航栏</p>-->
              <li class="geekMenuActive">
                <a href>首页</a>
              </li>
              <li>
                <router-link :to="{name: 'awards', params: {matchId:matchId,page:0}}">
                  获奖公示
                  <img src="/static/geeknext.png" alt />
                </router-link>
              </li>
              <li>
                <router-link :to="{name: 'entries', params: {matchId:matchId,page:0}}">
                  入围作品
                  <img src="/static/geeknext.png" alt />
                </router-link>
              </li>
              <li>
                <router-link :to="{name: 'works', params: {matchId:matchId,page:1}}">
                  参赛作品
                  <img src="/static/geeknext.png" alt />
                </router-link>
              </li>
              <li>
                <router-link :to="{name: 'works', params: {matchId:matchId,page:2}}">
                  近期事件
                  <img src="/static/geeknext.png" />
                </router-link>
              </li>
            </ul>
          </div>
          <span class="baroads" @click="signGoTo" v-show="matchObject.status == 1">报名通道</span>
          <a class="baroads unbaroads" v-show="matchObject.status == 1"></a>
          <div></div>
        </div>
        <!--赛事介绍-->
        <div class="introstart">
          <h3 class="geekSizeTitle firsttitle">赛事背景</h3>
          <div class="titleNext">
            <img src="/static/titleNext.png" alt />
          </div>
          <div class="geekDetails">
            <p>
              <strong>2019 “现未来”科技艺术之星奖</strong>
            </p>
            <p>旨在激励以科技为媒介进行创作的未来艺术之星</p>
            <p>汇聚全球顶尖科技与艺术新锐人才</p>
            <p>共同构建科技与艺术、教育与实践、创作与产业的跨界交流协作平台</p>
          </div>
        </div>

        <div class="eventIntroduction eventOverview">
          <h3 class="geekSizeTitle">征集对象</h3>
          <div class="titleNext">
            <img src="/static/titleNext.png" alt />
          </div>
          <div class="geekDetails">
            <p>
              <strong>全球科技艺术创作者</strong>
            </p>
            <p>*注：参赛者可以个人或团队名义提交作品</p>
          </div>

          <h3 class="geekSizeTitle">参赛类别</h3>
          <div class="titleNext">
            <img src="/static/titleNext.png" alt />
          </div>
          <div class="geekDetails aiintelligent">
            <p>
              <b style="font-size:16px;">人工智能</b>
            </p>
            <p>通过使用某种形式的人工智能技术创作出的优秀艺术作品，推进新型艺术表达形式和艺术家的创造性</p>
            <p class="aititle">
              <b style="font-size:16px;">交互</b>
            </p>
            <p>通过技术与艺术的连接，让观众“走进”作品或与之互动，建立起人与作品之间的一种新型关系</p>

            <p class="aititle">
              <b style="font-size:16px;">装置</b>
            </p>
            <p>通过对多种媒介材料进行艺术性地选择、利用、改造、组合，加之创作者特定想法，赋予材</p>
            <p>料新的艺术内涵</p>
            <p class="aititle">
              <b style="font-size:16px;">投影</b>
            </p>
            <p>通过投影、影像、声音等多种媒介，在光影变换中展现创作者艺术表达</p>
            <p class="aititle">
              <b style="font-size:16px;">影像</b>
            </p>
            <p>通过数字化创作，以纯视觉形式表达的优秀影像作品</p>
            <p class="aititle">
              <b style="font-size:16px;">游戏</b>
            </p>
            <p>游戏作为“第九艺术”，具有技术性、互动性、娱乐性，创作者以游戏作为媒介来表达自己的艺术想法</p>
          </div>

          <h3 class="geekSizeTitle">参赛要求</h3>
          <div class="titleNext">
            <img src="/static/titleNext.png" alt />
          </div>
          <div class="geekDetails">
            <p class="gameclaim">所有参赛者或团队以视频和文字为媒介进行作品介绍</p>
            <p class="gameclaim">1.上传原创视频（分辨率不小于1280*720像素，MP4/MOV格式输出作品）</p>
            <p class="gameclaim">2.原创作品图片5张（分辨率不小于1280*720像素）</p>
            <p class="gameclaim">3.1000字之内作品说明（包括标题、作品简介中英文版）</p>
            <p class="gameclaim">4.联系方式（邮箱及手机）</p>
            <p class="gameclaim">5.中英文创作者/团队介绍、创作者真实姓名</p>
          </div>

          <h3 class="geekSizeTitle">参赛时间</h3>
          <div class="titleNext">
            <img src="/static/titleNext.png" alt />
          </div>
          <div class="geekDetails">
            <p>
              <strong>公开征集作品截止日期2019年4月30日8:00 &nbsp;am</strong> （北京时间）
            </p>
            <p>
              <strong>入围名单公布 2019年5月10日</strong>
            </p>
            <p>（入围作品将通过赛事官方网站平台公布）</p>

            <p>
              <strong>举办“现未来”科技艺术之星盛典2019年5月31日（暂定）</strong>
            </p>
            <p></p>
            <p>
              <strong></strong>
            </p>
          </div>

          <div class="eventIntroduction prizeSettings">
            <h3 class="geekSizeTitle">奖项设置</h3>
            <div class="titleNext">
              <img src="/static/titleNext.png" alt />
            </div>
            <div class="geekDetails">
              <ul>
                <li>
                  <img src="/static/prize11.png" alt />
                  <div class="prizeSett1">最佳创意奖1名</div>
                  <div>奖金10000RMB（含税）</div>
                </li>

                <li class="nextLiTops">
                  <img src="/static/prize13.png" alt />
                  <div class="prizeSett1">单项奖6名</div>
                  <div>每项奖金3000RMB（含税）</div>
                </li>
                <li class="nextLiTops">
                  <img src="/static/prize14.png" alt />
                  <div class="prizeSett1">新锐奖1名</div>
                  <div>奖金3000RMB（含税）</div>
                </li>
              </ul>
            </div>
          </div>
          <p class="do-line-f"></p>
          <p class="do-line-t"></p>
          <div class="awardDescription">奖项说明</div>
          <div class="textAward">
            <span>1.</span>
            <p>奖项设立三大类：最佳创意奖1名；单项奖6名，设立人工智能、交互、装置、投影艺术、影像、游戏6个类别；新锐奖1名，颁发2019“现未来”科技艺术之星奖金、奖杯、证书</p>
          </div>
          <div class="textAward">
            <span>2.</span>
            <p>入围作品均可享受参与2019“现未来”科技艺术之星奖 ——“现未来”科技艺术之星盛典拍卖</p>
          </div>
          <div class="textAward">
            <span>3.</span>
            <p>所有入围者均可享受组委会提供的福利课程、主题性讲座和分享会，探讨新媒体艺术作品品牌化推广及项目落地等相关话题</p>
          </div>
          <div class="textAward">
            <span>4.</span>
            <p>所有入围作品将有机会由组委会及大赛合作单位链接产业链进行合作孵化</p>
          </div>

          <div class="awardDescription usernametion">评审流程说明</div>
          <div class="textAward">
            <span>1.</span>
            <p>初赛与复赛均由2019“现未来”科技艺术之星奖组委会从专业度、艺术表现、创造力、投资价值等维度对作品进行打分。大赛评委由行业专家、学院领导、重要企业代表等组成</p>
          </div>
          <div class="textAward">
            <span>2.</span>
            <p>初赛评审入围作品80件，入围作品将在赛事官方网站上进行公示</p>
          </div>
          <div class="textAward">
            <span>3.</span>
            <p>最终获奖名单将于5月31日举办的颁奖盛典中揭晓，并在赛事官网公布</p>
          </div>

          <!--评审团队-->
          <div class="prizeSettings pssetting">
            <h3 class="geekSizeTitle">评审团队</h3>
            <div class="titleNext">
              <img src="/static/titleNext.png" alt />
            </div>
            <div class="personalTeams">
              <ul>
                <li>
                  <img class="pngsize" src="/static/RoyAscott.png" alt />
                  <div class="teamName">Roy Ascott 罗伊·阿斯科特</div>
                  <p class="judgeIcon"></p>
                  <div class="presentation">
                    <span>
                      国际新媒体艺术先驱、德稻大师、
                      <br />英国普利茅斯大学星球学院创
                      <br />会主席、艺术家、理论家
                    </span>
                  </div>
                </li>

                <li class="teamLeft">
                  <img class="pngsize" src="/static/mrwang.png" alt />
                  <div class="teamName">汪建强</div>
                  <p class="judgeIcon"></p>
                  <div class="presentation">
                    <span>
                      上海视觉艺术学院新媒体艺术学院执行院长、
                      <br />华东电视技术协会主席、
                      <br />中国电影电视技术学会副理事长
                    </span>
                  </div>
                </li>

                <li>
                  <img class="pngsize" src="/static/mrzhang.png" alt />
                  <div class="teamName">张颂华</div>
                  <p class="judgeIcon"></p>
                  <div class="presentation">
                    <span>上海广播电视台东方卫视中心副总监</span>
                  </div>
                </li>

                <li class="teamLeft teamTops">
                  <img class="pngsize" src="/static/MikeStubbs.png" alt />
                  <div class="teamName" style="position: relative">Mike Stubbs 迈克·斯塔布</div>
                  <p class="judgeIcon"></p>
                  <div class="presentation">
                    <span>英国Creative Doncaster 20-22创意监制、FACT（英国）前CEO、利物浦约翰摩尔大学艺术-媒体及策展专业教授、艺术家、策展人</span>
                  </div>
                </li>

                <li class="teamTops">
                  <img class="pngsize" src="/static/GunalanNadarajan.png" alt />
                  <div class="teamName" style="position: relative">
                    Gunalan Nadarajan 古纳南
                    <span class="nitxt"></span>
                  </div>
                  <p class="judgeIcon"></p>
                  <div class="presentation">
                    <span>密歇根大学艺术设计学院院长、艺术理论家、策展人</span>
                  </div>
                </li>

                <li class="teamTops">
                  <img class="pngsize" src="/static/tiem4.png" alt />
                  <div class="teamName">冯峰</div>
                  <p class="judgeIcon"></p>
                  <div class="presentation">
                    <span>广州美术学院跨媒体学院院长、艺术家、策展人</span>
                  </div>
                </li>

                <li class="teamTops lastusername">
                  <img class="pngsize" src="/static/tiem5.png" alt />
                  <div class="teamName">薛峰</div>
                  <p class="judgeIcon"></p>
                  <div class="presentation">
                    <span>南京艺术学院传媒学院教授、中国当代动画艺术资料馆执行馆长、策展人、艺术评论人</span>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <h3 class="geekSizeTitle">举办单位</h3>
          <div class="titleNext">
            <img src="/static/titleNext.png" alt />
          </div>
          <h3 class="geekSizeTitle zuTitle">主办方</h3>
          <div class="geekDetails" style="margin-top: 10px;">
            <p class="sizecolor" style="color:#666;">
              <strong>“现未来”科技艺术之星奖组委会</strong>
            </p>
            <br />
            <p style="color: #ccc;">组委会成员（排名不分先后）：</p>
            <p>上海广播电视台艺术人文频道</p>
            <p>上海视觉艺术学院新媒体艺术学院</p>
            <p>密歇根大学艺术设计学院</p>
            <p>广州美术学院跨媒体学院</p>
            <p>南京艺术学院传媒学院</p>
            <p>MANA全球新媒体艺术平台</p>
          </div>

          <div class="geekDetails">
            <p>组委会将持续邀请、吸纳在艺术科技领域具有使命感的优秀从业机构与个人加入，凝</p>
            <p>聚全行业资源，促进艺术科技行业的蓬勃发展。</p>
          </div>

          <!--<h3 class="geekSizeTitle zuTitle">赞助方</h3>
          <div class="geekDetails apu30" style="margin-top: 10px;">
            <p>disguise</p>
          </div>-->

          <h3 class="geekSizeTitle zuTitle">合作方</h3>
          <p style="color: #666;margin-top:10px;font-size:14px">Unity</p>
          <p style="color: #666;margin-top:10px;font-size:14px">disguise</p>
          <p style="color: #666;margin-top:10px;font-size:14px">蓝海创意云</p>
          <p style="color: #666;margin-top:10px;font-size:14px">京东拍卖</p>
          <h3 class="geekSizeTitle zuTitle">特别支持方</h3>
          <p style="color: #666;margin-top:10px;font-size:14px">恩维传媒</p>
          <!--        <div class="logoarea">
            <p class="firstlogo">   <img src="/static/chlogo.png" >  <img src="/static/shlogo.png" >  <img src="/static/manalogo.png" >  </p>
            <p class="lastlogo"> <img src="/static/jdlogo.png" >  <img src="/static/dislogo.png" > <img src="/static/unity.png" > </p>
          </div>-->
          <div class="geekDetails">
            <p>2019“现未来”科技艺术之星奖组委会联系方式：</p>
            <p>Tel：0086 173-1783-8050</p>
            <p class="ponment">Email: pftas@manamana.net</p>
            <!--<p class="ponment">官方网站：www.manamana.net/match/presentfuture</p>-->
          </div>
          <span class="baroads" @click="signGoTo" v-show="matchObject.status == 1">报名通道</span>
        </div>
      </div>
    </div>
    <div class="do-competition contantGeek" v-else>
      <div class="geekBoxs eventintros">
        <div class="geekBanner">
          <div class="do-banner">
            <img src="/static/geekBanner.jpg" alt />
          </div>
          <div class="rightNavList">
            <ul>
              <!--<p>导航栏</p>-->
              <li class="geekMenuActive">
                <a href>Home</a>
              </li>
              <li>
                <router-link :to="{name: 'awards', params: {matchId:matchId,page:0}}">
                  Awards
                  <img src="/static/geeknext.png" alt />
                </router-link>
              </li>
              <li>
                <router-link :to="{name: 'entries', params: {matchId:matchId,page:0}}">
                  Shortlisted
                  <img src="/static/geeknext.png" alt />
                </router-link>
              </li>
              <li>
                <router-link :to="{name: 'works', params: {matchId:1003,page:1}}">
                  Exhibition
                  <img src="/static/geeknext.png" alt />
                </router-link>
              </li>
              <li>
                <router-link :to="{name: 'works', params: {matchId:1003,page:2}}">
                  Events
                  <img src="/static/geeknext.png" />
                </router-link>
              </li>
            </ul>
          </div>
          <span class="baroads" @click="signGoTo" v-show="matchObject.status == 1">Sign up</span>
          <a class="baroads unbaroads" v-show="matchObject.status == 1"></a>
          <div></div>
        </div>
        <!--赛事介绍-->
        <div class="introstart">
          <h3 class="geekSizeTitle firsttitle">Background/What Our Mission Is</h3>
          <div class="titleNext">
            <img src="/static/titleNext.png" alt />
          </div>
          <div class="geekDetails">
            <p>
              <strong>2019 “Present Future” Art & Technology Star Award</strong>
            </p>
            <p>Encourage future stars to create an art combined with technology</p>
            <p>Gather global creative talents from the disciplines such as technology and art</p>
            <p>Establish a sophisticated platform for communication about art and</p>
            <p>technology, education and practice, creation and cross-border industries</p>
          </div>
        </div>

        <div class="eventIntroduction eventOverview">
          <h3 class="geekSizeTitle">Who We Are Looking For</h3>
          <div class="titleNext">
            <img src="/static/titleNext.png" alt />
          </div>
          <div class="geekDetails">
            <p>
              <strong>Global Art & Technology Creators</strong>
            </p>
            <p>*Note: All competitors shall submit their works individually or in a team</p>
          </div>

          <h3 class="geekSizeTitle">Competition Categories</h3>
          <div class="titleNext">
            <img src="/static/titleNext.png" alt />
          </div>
          <div class="geekDetails aiintelligent">
            <p>
              <b style="font-size:16px;">AI</b>
            </p>
            <p>Use some form of AI technology to create excellent works of art,</p>
            <p>promote new forms of artistic expression and the creativity of artists</p>
            <p class="aititle">
              <b style="font-size:16px;">Interaction</b>
            </p>
            <p>Through the connection between technology and art, push the audience "enter" the work or</p>
            <p>interact with it, and establish a new relationship between people and the work</p>
            <p class="aititle">
              <b style="font-size:16px;">Installation</b>
            </p>
            <p>Through artistic selection, utilization, transformation and combination of a variety of</p>
            <p>media materials, as well as specific ideas of creators, new artistic connotation</p>
            <p>is endowed to the materials</p>
            <p class="aititle">
              <b style="font-size:16px;">Projection Art</b>
            </p>
            <p>Through projection, image, sound and other media, show the artist's artistic expression</p>
            <p>in the light and shadow transformation</p>
            <p class="aititle">
              <b style="font-size:16px;">Film</b>
            </p>
            <p>Excellent video works expressed in pure visual form through digital creation</p>
            <p class="aititle">
              <b style="font-size:16px;">Game</b>
            </p>
            <p>As the "ninth art", game is technical, interactive and entertaining. Creators use game as</p>
            <p>a medium to express their artistic ideas</p>
          </div>

          <h3 class="geekSizeTitle">Entry Requirements</h3>
          <div class="titleNext">
            <img src="/static/titleNext.png" alt />
          </div>
          <div class="geekDetails">
            <p
              class="gameclaim"
            >Video and text shall be used by all participants or teams to introduce their works：</p>
            <p class="gameclaim">1.Upload original video (MP4/MOV, min. 1280*720 px)</p>
            <p class="gameclaim">2.5 Images of the original work (min. 1280*720 px)</p>
            <p class="gameclaim">3.Description of the work (including title, max. 500 words)</p>
            <p class="gameclaim">4.Contact information （E-mail address and phone number）</p>
            <p class="gameclaim">5.The participant’s or team’s short introduction</p>
          </div>

          <h3 class="geekSizeTitle">Competition Timeline</h3>
          <div class="titleNext">
            <img src="/static/titleNext.png" alt />
          </div>
          <div class="geekDetails">
            <p>
              <strong>Deadline for Submission: 2019.04.30, 8:00 am, Beijing Time</strong>
            </p>
            <p>
              <strong>Shortlist Announcement Date: 2019.05.10</strong>
            </p>
            <p>(Shortlisted works will be announced on the competition's official website)</p>
            <p>
              <strong>Expected Award Ceremony: May 31, 2019</strong>
            </p>
            <p></p>
            <p>
              <strong></strong>
            </p>
          </div>

          <div class="eventIntroduction prizeSettings">
            <h3 class="geekSizeTitle">Awards Setting</h3>
            <div class="titleNext">
              <img src="/static/titleNext.png" alt />
            </div>
            <div class="geekDetails">
              <ul>
                <li>
                  <img src="/static/prize11.png" alt />
                  <div class="prizeSett1">Best Creative Award (1 Award)</div>
                  <div>Prize: 10000RMB (Tax included)</div>
                </li>

                <li class="nextLiTops">
                  <img src="/static/prize13.png" alt />
                  <div class="prizeSett1">Individual Awards (6 Awards)</div>
                  <div>Prize: 3000RMB (Tax included)</div>
                </li>
                <li class="nextLiTops">
                  <img src="/static/prize14.png" alt />
                  <div class="prizeSett1">Infinity Award (1 Award )</div>
                  <div>Prize: 3000RMB (Tax included)</div>
                </li>
              </ul>
            </div>
          </div>
          <p class="do-line-f"></p>
          <p class="do-line-t"></p>
          <div class="awardDescription">Award Description</div>
          <div class="textAward">
            <span>1.</span>
            <p>The awards are divided into three categories: one Best Creative Award; six Individual Awards, which are AI, interaction, installation, projection art, film and game; one Infinity Award. Moreover, we will customize the trophies, certificates and provide prizes</p>
          </div>
          <div class="textAward">
            <span>2.</span>
            <p>All shortlisted works are eligible to participate in the 2019 "Present Future" Art & Technology Star Award - "Present Future" Art & Technology Star Auction</p>
          </div>
          <div class="textAward">
            <span>3.</span>
            <p>All artists on shortlist are sincerely welcomed to join the welfare courses, thematic lectures and sharing sessions provided by the organizing committee and to discuss the branding promotion of new media art works, project implementation and other related topics</p>
          </div>
          <div class="textAward">
            <span>4.</span>
            <p>All shortlisted works will have the opportunity to be incubated by the industrial chain linked by the organizing committee and cooperators</p>
          </div>

          <div class="awardDescription usernametion">The Selection Rules</div>
          <div class="textAward">
            <span>1.</span>
            <p>Both preliminary and final competitors are scored by the organizing committee from the perspectives of professionalism, artistic expression, creativity and investment value. The competition judges are composed of industry experts, college leaders and representatives of important enterprises</p>
          </div>
          <div class="textAward">
            <span>2.</span>
            <p>80 shortlisted works will be evaluated in the preliminary competition, which will be published on the competition's official website</p>
          </div>
          <div class="textAward">
            <span>3.</span>
            <p>The winners will be announced in the ceremony held in May 31 and be published on the competition's official website</p>
          </div>

          <!--评审团队-->
          <div class="prizeSettings pssetting">
            <h3 class="geekSizeTitle">Competition Judges</h3>
            <div class="titleNext">
              <img src="/static/titleNext.png" alt />
            </div>
            <div class="personalTeams">
              <ul>
                <li>
                  <img class="pngsize" src="/static/RoyAscott.png" alt />
                  <div class="teamName">Roy Ascott</div>
                  <p class="judgeIcon"></p>
                  <div class="presentation">
                    <span>Pioneer of New Media Art; DeTao Master, Founder chairman of Planetary Collegium, University of Plymouth, UK; Artist; Theorist</span>
                  </div>
                </li>

                <li class="teamLeft">
                  <img class="pngsize" src="/static/mrwang.png" alt />
                  <div class="teamName">Wang Jianqiang</div>
                  <p class="judgeIcon"></p>
                  <div class="presentation">
                    <span>Dean of School of New Media Art ,Shanghai Institute of Visual Art; President of East China TV Technology League; Vice President of China Society of Motion Picture and Television Engineers</span>
                  </div>
                </li>

                <li>
                  <img class="pngsize" src="/static/mrzhang.png" alt />
                  <div class="teamName">Zhang Songhua</div>
                  <p class="judgeIcon"></p>
                  <div class="presentation">
                    <span>Deputy Director of Dragon TV, Shanghai Media Group</span>
                  </div>
                </li>

                <li class="teamLeft teamTops">
                  <img class="pngsize" src="/static/MikeStubbs.png" alt />
                  <div class="teamName" style="position: relative">Mike Stubbs</div>
                  <p class="judgeIcon"></p>
                  <div class="presentation">
                    <span>Creative Producer for Doncaster Creates 20-22;FACT (UK) former CEO; Professor of Art, Media and Curating of Liverpool John Moores University in 2007; Artist; Curator</span>
                  </div>
                </li>

                <li class="teamTops">
                  <img class="pngsize" src="/static/GunalanNadarajan.png" alt />
                  <div class="teamName" style="position: relative">
                    Gunalan Nadarajan
                    <span class="nitxt"></span>
                  </div>
                  <p class="judgeIcon"></p>
                  <div class="presentation">
                    <span>Dean and Professor at the Stamps School of Art and Design, University of Michigan; Art Theorist; Curator</span>
                  </div>
                </li>

                <li class="teamTops">
                  <img class="pngsize" src="/static/tiem4.png" alt />
                  <div class="teamName">Feng Feng</div>
                  <p class="judgeIcon"></p>
                  <div class="presentation">
                    <span>Dean of Institute of Experimental Art of Guangzhou Academy of Fine Arts; Artist; Curator</span>
                  </div>
                </li>

                <li class="teamTops lastusername">
                  <img class="pngsize" src="/static/tiem5.png" alt />
                  <div class="teamName">Xue Feng</div>
                  <p class="judgeIcon"></p>
                  <div class="presentation">
                    <span>Professor of Media College of Nanjing Arts Institute; Executive director of China Contemporary Animation Art Archive；Curator; Art critic</span>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <h3 class="geekSizeTitle">Host Units</h3>
          <div class="titleNext">
            <img src="/static/titleNext.png" alt />
          </div>
          <h3 class="geekSizeTitle zuTitle">Organizer</h3>
          <div class="geekDetails" style="margin-top: 10px;">
            <p class="sizecolor" style="color:#666;">
              <strong>“Present Future” Art & Technology Star Award Organizing Committee</strong>
            </p>
            <br />
            <p style="color: #ccc;">Organizing Committee Member (In no particular order):</p>
            <p>SMG Art Media Channel</p>
            <p>Shanghai Institute of Visual Art</p>
            <p>University of Michigan, Penny W. Stamps School of Art & Design</p>
            <p>Guangzhou Academy of Fine Arts, Institute of Intermedia Art</p>
            <p>Media College of Nanjing Arts Institute</p>
            <p>MANA Global New Media Art Platform</p>
          </div>

          <div class="geekDetails">
            <p>The organizing committee will continue inviting and attracting outstanding professional institutions</p>
            <p>and individuals with a sense of mission in the field of art and technology to join, gather resources</p>
            <p>of the whole industry, and promote the vigorous development of the art and technology industry</p>
          </div>

          <!--<h3 class="geekSizeTitle zuTitle">Sponsor</h3>
          <div class="geekDetails apu30" style="margin-top: 10px;">
            <p>disguise</p>
          </div>-->

          <h3 class="geekSizeTitle zuTitle">Cooperator</h3>
          <p style="color: #666;margin-top:10px;font-size:14px">Unity</p>
          <p></p>
          <p style="color: #666;margin-top:10px;font-size:14px">disguise</p>
          <p style="color: #666;margin-top:10px;font-size:14px">VSOCloud</p>
          <p style="color: #666;margin-top:10px;font-size:14px">JD Auction</p>
          <h3 class="geekSizeTitle zuTitle">Sponsor</h3>
          <p style="color: #666;margin-top:10px;font-size:14px">N Dimensions Media</p>
          <p>
            <!--        <div class="logoarea">
                    <p class="firstlogo">   <img src="/static/chlogo.png" >  <img src="/static/shlogo.png" >  <img src="/static/manalogo.png" >  </p>
                    <p class="lastlogo"> <img src="/static/jdlogo.png" >  <img src="/static/dislogo.png" > <img src="/static/unity.png" > </p>
            </div>-->
          </p>
          <div class="geekDetails">
            <p>For further details, please contact us:</p>
            <p>“ Present Future ”Art & Technology Star Award Organizing Committee</p>
            <p>Tel: 0086 173-1783-8050</p>
            <p>E-mail: pftas@manamana.net</p>
            <!--<p class="ponment">Website：en.manamana.net/activity/match</p>-->
          </div>
          <span class="baroads" @click="signGoTo" v-show="matchObject.status == 1">Sign up</span>
        </div>
      </div>
    </div>
  </main-layout>
</template>

<script>
import "./css/lifePz.css";
import MainLayout from "@/layouts/MainLayout";

export default {
  name: "IndexPage",
  metaInfo() {
    return {
      title: this.$t("global.2019“现未来”科技艺术之星奖-竞赛介绍") + " | MANA"
    };
  },
  components: {
    MainLayout
  },
  data() {
    return {
      matchId: -1,
      matchObject: {}
    };
  },
  computed: {
    language() {
      return this.$language();
    }
  },
  created() {
    this.matchId = this.$route.params.matchId || 1003;
    // if (this.matchId != -1) {
    //   this.$http
    //     .get("/api/match/getMatch", { params: { matchId: this.matchId } })
    //     .then(res => {
    //       if (res.code === "OK") {
    //         this.matchObject = res.data;
    //       }
    //     });
    // }
  },
  methods: {
    signGoTo() {
      if (!this.$store.state.peopleMessage) {
        this.$router.push("/login");
        return;
      }
      debugger;
      let $this = this;
      this.$http
        .post(
          "/api/match/user/checkIsMatch?userId=" +
            this.$store.state.peopleMessage.userId +
            "&matchId=" +
            this.matchId
        )
        .then(response => {
          if (response.code == 400) {
            $this.$router.push({ path: "/signupZ?matchId=" + this.matchId });
          } else {
            this.$router.push({ path: "/UpVideo?matchId=" + this.matchId });
          }
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/match/eventintroPz.vue